import { Component } from '@angular/core';

@Component({
    selector: 'app-site-overview-info',
    imports: [],
    templateUrl: './site-overview-info.component.html',
    standalone: true,
    styleUrl: './site-overview-info.component.scss'
})
export class SiteOverviewInfoComponent {

}
